import React, { useState, useEffect } from 'react';
import GetNavLink from '../../utils/getNavLink';
import styles from './header.module.css';
import SocialMediaLinks from '../../utils/SocialMediaLinks';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Header = () => {
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  //  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setIsScrollingDown(true);
      } else {
        setIsScrollingDown(false);
        // setIsHeaderVisible(true); // Ensure visibility on scroll up
      }

      setLastScrollY(currentScrollY);
    };

    const handleTouchStart = (event) => {
      if (
        !event.target.closest(`.${styles.header}`) &&
        !event.target.closest(`.${styles.navLinks}`) &&
        !event.target.closest(`.${styles.socialMedia}`)
      ) {
        return; // Do nothing on touch, prevent hiding header
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('touchstart', handleTouchStart); // Prevent unnecessary header hiding on touch

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('touchstart', handleTouchStart);
    };
  }, [lastScrollY]);

  return (
    <>
      <Helmet>
        <title>Studio Maamangala | Wedding Photography, Videography & Cinematography</title>
        <meta name="description" content="Studio Maamangala is a creative visual studio specializing in wedding photography, pre-wedding shoots, cinematic videography, and event coverage. Capture timeless memories with us." />
        <meta name="keywords" content="wedding photography, cinematic videography, pre-wedding shoot, photography studio, wedding cinematography, event photography, Studio Maamangala" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Studio Maamangala | Wedding & Event Photography Studio" />
        <meta property="og:description" content="Creative storytelling through visuals – wedding photography, cinematic films, and pre-wedding shoots by Studio Maamangala." />
        <meta property="og:image" content="https://studiomaamangala.com/wp-content/uploads/2025/02/og-cover.jpg" />
        <meta property="og:url" content="https://studiomaamangala.com" />
        <meta property="og:type" content="business.business" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Studio Maamangala | Visual Storytelling Studio" />
        <meta name="twitter:description" content="Wedding & event photography, cinematic videography and more." />
        <meta name="twitter:image" content="https://studiomaamangala.com/wp-content/uploads/2025/02/og-cover.jpg" />

        {/* Structured Data - Studio Business Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "PhotographyStudio",
            "name": "Studio Maamangala",
            "image": "https://studiomaamangala.com/wp-content/uploads/2025/02/mmstudio.svg",
            "url": "https://studiomaamangala.com",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Baripada",
              "addressRegion": "Odisha",
              "addressCountry": "India"
            },
            "description": "Professional photography and cinematography studio for weddings, pre-weddings, and events.",
            "sameAs": [
              "https://www.facebook.com/hemantasahu9583/",
              "https://www.instagram.com/maa_mangala_studio/",
              "https://wa.me/8328803919"
            ]
          })}
        </script>
      </Helmet>

      <header
        className={`${styles.header} ${isScrollingDown ? styles.headerHidden : styles.headerVisible
          }`}
      >
        <div style={{ display: 'flex', gap: '2rem' }}>
          <div className={styles.logo}>
            <Link to="/" className={styles.logoLink} aria-label="Go to homepage">
              <img
                src={`https://studiomaamangala.com/wp-content/uploads/2025/02/mmstudio.svg`}
                alt="logo SVG"
                width={60} // Bigger Image
                height={50}
              />
            </Link>
          </div>
          <GetNavLink className={styles.navLinks} />
        </div>
        <SocialMediaLinks className={styles.socialMedia} />
      </header>
    </>
  );
};

export default Header;
